<template>
    <div class="vm-footer-custom">
        <div class="inner-box fs14 pt200 flex-a-center">
            <div class="black-5 mr16 gl-hover-text flex-box flex-a-center" @click="open_lang"><i class="mr8 afd afd-earth"></i>{{$t('c.FooterCustom.text11')}}<i class="ml8 afd afd-arrow-down"></i></div>
            <div class="black-5">© {{year}} afdian.net</div>
            <router-link
                class="ml16 black-5 gl-hover-text"
                to="/album/248b4bb2c9b111e9a9bb52540025c377/92aa33b68b4a11e8aa6952540025c377"
            >{{$t('c.FooterCustom.text1')}}</router-link>
            <router-link class="ml16 black-5 gl-hover-text" :to="{name:'term'}">{{$t('c.FooterCustom.text2')}}</router-link>
            <a
                class="ml16 black-5 gl-hover-text"
                href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
                target="_blank"
                v-if="locale_lang == 'zh-CN'"
            >{{$t('c.FooterCustom.text3')}}</a>
            <!--<div class="ml16" v-show="$route.name == 'index'">-->
            <!--<wb:follow-button uid="6512497131" type="red_1" width="67" height="24" ></wb:follow-button>-->
            <!--</div>-->
            <div class="ml16 black-5" v-if="locale_lang == 'zh-CN'">{{$t('c.FooterCustom.text4')}}</div>
        </div>
        <div class="inner-box fs14">
            <a class="black-5 gl-hover-text" href="https://afdian.net/p/d74eef386ad211eb87a052540025c377" target="_blank">{{$t('c.FooterCustom.text5')}}</a>
            <a class="ml16 black-5 gl-hover-text" href="https://afdian.net/album/248b4bb2c9b111e9a9bb52540025c377" target="_blank">{{$t('c.FooterCustom.text6')}}</a>
            <a
                class="ml16 black-5 gl-hover-text"
                href="mailto:lain@afdian.net"
                target="_blank"
            >{{$t('c.FooterCustom.text7')}}lain@afdian.net</a>
        </div>
        <div class="inner-box fs14">
            <a v-if="locale_lang == 'zh-CN'" class="black-5 gl-hover-text" :href="$route.name == 'index' ? 'https://12377.cn/' : false" target="_blank">{{$t('c.FooterCustom.text8')}}</a>
            <a
              v-if="locale_lang == 'zh-CN'"
                class="ml16 black-5 gl-hover-text"
                href="mailto:report@afdian.net"
                target="_blank"
            >{{$t('c.FooterCustom.text9')}}report@afdian.net</a>
            <span v-if="locale_lang == 'zh-CN'" class="gl-hover-text ml8 black-5">15600530672 ({{$t('c.FooterCustom.text10')}} 10:00 ~ 18:00)</span>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "footer-custom",
  props: {},
  inject:['app_action_sheet'],
  components: {},
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
  computed: {
    ...mapState("app", [
        "locale_lang",
    ]),
  },
  mounted() {
  },
  methods: {
    open_lang(e){
      this.app_action_sheet('open', {
        component:'action-lang',
        classname: 'lang'
      })
    }
  }
};
</script>

<style lang="stylus" scoped>
.vm-footer-custom {
    display: flex;
    align-items: center;
    flex-direction: column;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;

    .inner-box {
        box-sizing: border-box;
        max-width: $width-pc;
        margin: 0 auto;
        width: 100%;
        display: flex;
        padding-bottom: px2rem(40);
    }
    .pt200{
        padding-top:200px;
    }
    &.relative {
        position: relative;
    }
}
</style>
